/* Plot & Harvest collection page (v1 3-10-2026): chooser, filters, sort, compare, basket, read more */
(function () {
  'use strict';
  var SEP = '¦';
  function $(sel, el) { return (el || document).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  $$('[data-ph-col]').forEach(function (root) {
    var grid = $('[data-grid]', root);
    if (!grid) return;
    var cards = $$('[data-card]', grid);
    var noun = root.getAttribute('data-noun') || 'designs';
    var state = { type: '', pmin: 0, pmax: Infinity, kw: '', sort: 'featured' };

    /* ---- type chips, in rule order, with counts ---- */
    var order = (root.getAttribute('data-types') || '').split(SEP).filter(Boolean);
    var counts = {};
    cards.forEach(function (c) { var t = c.getAttribute('data-type'); if (t) counts[t] = (counts[t] || 0) + 1; });
    Object.keys(counts).forEach(function (t) { if (order.indexOf(t) < 0) order.push(t); });
    order = order.filter(function (t) { return counts[t]; });
    var typeBox = $('[data-type-chips]', root);
    if (typeBox) {
      if (order.length < 2) typeBox.hidden = true;
      else {
        var html = '<button type="button" class="ph-chip" aria-pressed="true" data-t="">All<span class="ph-chip__n">' + cards.length + '</span></button>';
        order.forEach(function (t) { html += '<button type="button" class="ph-chip" aria-pressed="false" data-t="' + esc(t) + '">' + esc(t) + '<span class="ph-chip__n">' + counts[t] + '</span></button>'; });
        typeBox.innerHTML = html;
      }
    }

    function matches(c, st) {
      var p = parseInt(c.getAttribute('data-price'), 10) || 0;
      if (st.type && c.getAttribute('data-type') !== st.type) return false;
      if (p < st.pmin || p >= st.pmax) return false;
      if (st.kw && (c.getAttribute('data-kw') || '').indexOf(st.kw) < 0) return false;
      return true;
    }
    function syncChips() {
      $$('[data-t]', root).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-t') === state.type ? 'true' : 'false'); });
      $$('[data-pmin]', root).forEach(function (b) { b.setAttribute('aria-pressed', (+b.getAttribute('data-pmin') === state.pmin && +b.getAttribute('data-pmax') === state.pmax) ? 'true' : 'false'); });
      $$('[data-kw-chip]', root).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-kw-chip') === state.kw ? 'true' : 'false'); });
    }
    function apply() {
      var list = cards.slice();
      if (state.sort !== 'featured') {
        list.sort(function (a, b) {
          if (state.sort === 'title') return a.getAttribute('data-title').localeCompare(b.getAttribute('data-title'));
          var d = (+a.getAttribute('data-price')) - (+b.getAttribute('data-price'));
          return state.sort === 'price-asc' ? d : -d;
        });
      } else {
        list.sort(function (a, b) { return +a.getAttribute('data-i') - +b.getAttribute('data-i'); });
      }
      var n = 0;
      list.forEach(function (c) { var ok = matches(c, state); c.hidden = !ok; if (ok) n++; grid.appendChild(c); });
      var cnt = $('[data-count]', root); if (cnt) cnt.textContent = n;
      var on = state.type || state.pmin || state.pmax !== Infinity || state.kw;
      $$('.ph-bar [data-reset]', root).forEach(function (b) { b.hidden = !on; });
      var empty = $('[data-empty]', root); if (empty) empty.hidden = n > 0;
      syncChips();
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-t]');
      if (t) { state.type = t.getAttribute('data-t'); apply(); return; }
      var p = e.target.closest('[data-pmin]');
      if (p) {
        var mn = +p.getAttribute('data-pmin'), mx = +p.getAttribute('data-pmax');
        if (state.pmin === mn && state.pmax === mx) { state.pmin = 0; state.pmax = Infinity; } else { state.pmin = mn; state.pmax = mx; }
        apply(); return;
      }
      var k = e.target.closest('[data-kw-chip]');
      if (k) { var v = k.getAttribute('data-kw-chip'); state.kw = state.kw === v ? '' : v; apply(); return; }
      if (e.target.closest('[data-reset]')) { state.type = ''; state.pmin = 0; state.pmax = Infinity; state.kw = ''; apply(); }
    });
    var sort = $('[data-sort]', root);
    if (sort) sort.addEventListener('change', function () { state.sort = sort.value; apply(); });

    /* ---- help me choose ---- */
    var opts = $$('[data-choose]', root);
    function chooseState(b) {
      return { type: b.getAttribute('data-ftype') || '', kw: b.getAttribute('data-fkw') || '', pmin: 0, pmax: Infinity };
    }
    opts.forEach(function (b) {
      var i = b.getAttribute('data-choose');
      var st = chooseState(b);
      var n = cards.filter(function (c) { return matches(c, st); }).length;
      var panel = $('[data-choose-panel="' + i + '"]', root);
      var nEl = panel && $('[data-choose-n]', panel); if (nEl) nEl.textContent = n;
      b.addEventListener('click', function () {
        opts.forEach(function (o) { o.setAttribute('aria-checked', o === b ? 'true' : 'false'); });
        $$('[data-choose-panel]', root).forEach(function (pn) { pn.hidden = pn.getAttribute('data-choose-panel') !== i; });
      });
      b.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var nx = opts[(opts.indexOf(b) + d + opts.length) % opts.length]; nx.focus(); nx.click();
      });
      b.tabIndex = b.getAttribute('aria-checked') === 'true' ? 0 : -1;
    });
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-choose-apply]');
      if (!a) return;
      var b = $('[data-choose="' + a.getAttribute('data-choose-apply') + '"]', root);
      var st = chooseState(b);
      state.type = st.type; state.kw = st.kw; state.pmin = 0; state.pmax = Infinity;
      apply();
      var target = $('.ph-bar', root) || grid;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    opts.forEach(function (b) { b.addEventListener('click', function () { opts.forEach(function (o) { o.tabIndex = o === b ? 0 : -1; }); }); });

    /* ---- compare (max 3) ---- */
    var tray = $('[data-tray]', root), dlg = $('[data-cmp-dialog]', root), picked = [];
    var labels = (root.getAttribute('data-cmp-labels') || '').split(SEP);
    function syncCmp() {
      cards.forEach(function (c) {
        var box = $('[data-cmp-box]', c), on = picked.indexOf(c) >= 0;
        box.checked = on;
        box.disabled = !on && picked.length >= 3;
        box.parentNode.classList.toggle('is-off', box.disabled);
        c.classList.toggle('is-picked', on);
      });
      if (!tray) return;
      tray.hidden = !picked.length;
      $('[data-tray-n]', tray).textContent = picked.length;
      $('[data-tray-thumbs]', tray).innerHTML = picked.map(function (c) { var im = c.getAttribute('data-img'); return im ? '<img src="' + esc(im) + '" alt="">' : ''; }).join('');
      $('[data-cmp-open]', tray).disabled = picked.length < 2;
      document.body.style.paddingBottom = picked.length ? tray.offsetHeight + 'px' : '';
    }
    grid.addEventListener('change', function (e) {
      if (!e.target.matches('[data-cmp-box]')) return;
      var c = e.target.closest('[data-card]'), i = picked.indexOf(c);
      if (e.target.checked && i < 0 && picked.length < 3) picked.push(c);
      if (!e.target.checked && i >= 0) picked.splice(i, 1);
      syncCmp();
    });
    var opener = null;
    function openCmp() {
      if (!dlg || picked.length < 2) return;
      var h = '<table><thead><tr><td></td>';
      picked.forEach(function (c) {
        var im = c.getAttribute('data-img');
        h += '<td class="ph-cmp__p">' + (im ? '<img src="' + esc(im) + '" alt="">' : '') + '<a class="ph-cmp__name" href="' + esc(c.getAttribute('data-url')) + '">' + esc(c.getAttribute('data-title')) + '</a><a class="ph-btn ph-btn--block" href="' + esc(c.getAttribute('data-url')) + '">View</a></td>';
      });
      h += '</tr></thead><tbody>';
      labels.forEach(function (lab, r) {
        var vals = picked.map(function (c) { return (c.getAttribute('data-cmp') || '').split(SEP)[r] || '—'; });
        if (vals.every(function (v) { return v === '—'; })) return;
        h += '<tr><th scope="row">' + esc(lab) + '</th>';
        vals.forEach(function (v) { h += '<td>' + esc(v) + '</td>'; });
        h += '</tr>';
      });
      h += '</tbody></table>';
      $('[data-cmp-body]', dlg).innerHTML = h;
      opener = document.activeElement;
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      document.documentElement.classList.add('ph-cmp-open');
      var x = $('[data-cmp-close]', dlg); if (x) x.focus();
    }
    function onClose() {
      document.documentElement.classList.remove('ph-cmp-open');
      if (opener && opener.focus) opener.focus();
    }
    function closeCmp() { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); onClose(); }
    if (tray) {
      $('[data-cmp-open]', tray).addEventListener('click', openCmp);
      $('[data-tray-clear]', tray).addEventListener('click', function () { picked = []; syncCmp(); });
    }
    if (dlg) {
      $('[data-cmp-close]', dlg).addEventListener('click', closeCmp);
      dlg.addEventListener('cancel', function (e) { e.preventDefault(); closeCmp(); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) closeCmp(); });
    }

    /* ---- add to basket without leaving the page (falls back to a normal submit) ---- */
    grid.addEventListener('submit', function (e) {
      var f = e.target.closest('.ph-col-add');
      if (!f || !window.fetch || !window.FormData) return;
      e.preventDefault();
      var btn = $('button[type="submit"]', f), label = btn.textContent;
      var msg = $('.ph-col-msg', f.parentNode);
      if (!msg) { msg = document.createElement('p'); msg.className = 'ph-col-msg'; msg.setAttribute('role', 'status'); f.after(msg); }
      btn.setAttribute('aria-busy', 'true'); btn.disabled = true; btn.textContent = 'Adding…';
      var root_ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root_ + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return fetch(root_ + 'cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          msg.className = 'ph-col-msg'; msg.innerHTML = 'Added. <a href="' + root_ + 'cart">View basket</a>';
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'ph-col', data: { itemCount: cart.item_count, source: 'ph-col' } } }));
        })
        .catch(function (err) {
          msg.className = 'ph-col-msg is-err';
          msg.textContent = (err && (err.description || err.message)) || 'Could not add this item. Please try again.';
        })
        .then(function () { btn.removeAttribute('aria-busy'); btn.disabled = false; btn.textContent = label; });
    });

    /* ---- guide text: read more ---- */
    var seo = $('[data-seo]', root), more = $('[data-seo-more]', root);
    if (seo && more && seo.scrollHeight > 220) {
      seo.classList.add('is-clamped'); more.hidden = false;
      more.addEventListener('click', function () {
        var open = seo.classList.toggle('is-clamped') === false;
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
        more.textContent = open ? 'Read less' : 'Read more';
      });
    }

    apply();
  });
})();
